










import { Component, Prop, Vue } from 'vue-property-decorator';
import { YouTubeBlockDto } from '@/api';

@Component({
  components: {},
})
export default class YouTubeBlock extends Vue {
  @Prop({required: true})
  public readonly model!: YouTubeBlockDto;

  public get src(): string {
    return 'https://www.youtube-nocookie.com/embed/' + this.model.viewKey;
  }
}
